import { useSelector } from 'src/store';
import { selectors } from 'src/store/navbar';

export const useSearchState = () => useSelector(selectors.selectSearch);
